<template>
  <main
    class="is-flex px-4 py-1"
    style="color: hsl(348deg, 86%, 61%); cursor: default"
  >
    <div
      class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center"
    >
      <div class="is-uppercase is-size-7">
        {{ $t("bnpl:transaction.label.delay") }}
      </div>
      <div class="has-text-grey is-size-7 has-text-centered">
        {{ formatDate(dueDate) }}
      </div>
    </div>
    <div class="is-flex is-align-items-center ml-3 has-text-weight-bold">
      {{ formatMoney(sum) }}
    </div>
  </main>
</template>

<script>
import { formatDate, formatMoney } from "@/utils/util";
export default {
  name: "BnplTransactionsDelay",
  methods: { formatDate, formatMoney },
  props: {
    dueDate: {
      type: [Date, String],
      require: true,
    },
    sum: {
      type: Number,
      require: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/colors.scss";

main {
  border: 1px solid $red;
  border-radius: 40px;
  height: 100%;
}
</style>
